import Tween from "tween.ts";
import Animation from "../../../../../../src/animation/Animation";
import Angle from "../../../../../../src/entities/Angle/Angle";

export default class RotateAngleAnimation extends Animation{
  constructor(angle:Angle, rotation:number, delay:number,onComp:()=>void){
    super();
    new Tween.Tween(angle)
    .to({rotation},500)
    .delay(delay)
    .onComplete(()=>onComp())
    .start()
  }
}